<template>
  <div
    :class="{ 'night-mode': currentGreetingKey === 'night01' }"
    :style="{ backgroundImage: 'url(' + currentBgImage + ')' }"
    class="header-card"
  >
    <div class="left-content">
      <!-- 左侧 emoji icon：根据时间段动态展示 -->
      <div v-if="timeIcon" class="time-icon">{{ timeIcon }}</div>
      <!-- 中间文案：主 + 副 -->
      <div class="greeting-wrap">
        <h2 class="greeting-title">{{ greetingTitle }}</h2>
        <p class="greeting-subtitle">{{ greetingSubtitle }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'DashboardHeader',
  data() {
    return {
      // 时间段问候语配置（文案中的 {name} 会替换为当前用户真实姓名）
      greetings: {
        morning: {
          cnPeriod: '早上好，{name}！新的一天开始了！☀️',
          ptPeriod: 'Bom dia, {name}! ☀️',
          cnIcon: '',
          ptIcon: '',
          // 对应 zaoshang.jpg
          bgImage: require('@/assets/images/welcomeImage/zhaoshang01.jpg'),
          timeRange: ['06:00', '12:00'],
          cnText: '愿今天有阳光，也有好心情。',
          ptText: 'Que o seu dia seja leve, tranquilo e cheio de coisas boas.'
        },
        noon: {
          cnPeriod: '午餐时间到了，好好休息一下吧 ☕',
          ptPeriod: 'Hora do almoço, aproveite para descansar um pouco ☕',
          cnIcon: '',
          ptIcon: '',
          // 对应 zhongwu.jpg
          bgImage: require('@/assets/images/welcomeImage/zhongwu01.jpg'),
          timeRange: ['12:00', '13:00'],
          cnText: '短暂放下手头的忙碌，享受属于自己的午间时光。',
          ptText:
            'Deixe a correria de lado por alguns minutos e aproveite o seu momento de descanso.'
        },
        afternoon: {
          cnPeriod: '下午好，包裹正在陆续送达',
          ptPeriod: 'Boa tarde, os pacotes estão sendo entregues aos poucos.',
          cnIcon: '',
          ptIcon: '',
          // 对应 xiawu.jpg
          bgImage: require('@/assets/images/welcomeImage/xiawu01.jpg'),
          timeRange: ['13:00', '18:00'],
          cnText: '每一个送达的包裹，都可能会为另一个人带去一份快乐。',
          ptText: 'Cada pacote entregue pode levar um pouco de alegria para alguém.'
        },
        afternoon02: {
          cnPeriod: '晚上好，忙碌的一天渐入夜色',
          ptPeriod: 'Boa noite! Mais um dia cheio de conquistas de verdade 🌙',
          cnIcon: '',
          ptIcon: '',
          // 对应 wangshang.jpg
          bgImage: require('@/assets/images/welcomeImage/wanshang01.jpg'),
          timeRange: ['18:00', '22:00'],
          cnText: '夕阳落下，转运中心依然有序运转。',
          ptText:
            'O sol se põe, enquanto as operações no centro de distribuição seguem normalmente.'
        },
        night01: {
          cnPeriod: '跨越昼夜，连接中国与巴西 🌙',
          ptPeriod: 'Atravessando o dia e a noite, conectando a China ao Brasil. 🌙',
          cnIcon: '',
          ptIcon: '',
          // 对应 shengye.jpg
          bgImage: require('@/assets/images/welcomeImage/zhouye01.jpg'),
          timeRange: ['22:00', '06:00'],
          cnText: '夜幕之下，国际包裹仍在持续运往巴西。',
          ptText: 'Mesmo durante a noite, os pacotes internacionais continuam a caminho do Brasil.'
        }
      },
      currentGreetingKey: 'morning'
    };
  },
  computed: {
    userRealName() {
      return this.$store.getters.realName || this.$store.getters.userName || '同事';
    },
    isZh() {
      return this.$i18n.locale === 'zh';
    },
    currentGreeting() {
      return this.greetings[this.currentGreetingKey] || this.greetings.morning;
    },
    // 新增：动态获取当前背景图路径
    currentBgImage() {
      return this.currentGreeting.bgImage;
    },
    greetingTitle() {
      // 主文案中的 {name} 占位符替换为当前用户真实姓名（无占位符则原样返回）
      const title = this.isZh ? this.currentGreeting.cnPeriod : this.currentGreeting.ptPeriod;
      return title.replace('{name}', this.userRealName);
    },
    // 副文案
    greetingSubtitle() {
      const g = this.currentGreeting;
      return this.isZh ? g.cnText : g.ptText;
    },
    // 时间段 emoji 图标
    timeIcon() {
      const g = this.currentGreeting;
      return this.isZh ? g.cnIcon : g.ptIcon;
    },
    // 右侧场景占位 emoji
    sceneEmoji() {
      return this.currentGreeting.sceneEmoji;
    }
  },
  mounted() {
    this.updateGreetingByTime();
    // 每分钟刷新一次（确保跨时间段时自动更新）
    this._timer = setInterval(this.updateGreetingByTime, 60 * 1000);
  },
  beforeDestroy() {
    if (this._timer) clearInterval(this._timer);
  },
  methods: {
    // 根据当前时间匹配时间段
    updateGreetingByTime() {
      const now = dayjs();
      const hour = Number(now.hour()); // 或者 now.format('HH')
      const g = this.greetings;
      // 跨天区间（22:00~06:00）需要单独判断
      if (hour >= 22 || hour < 6) {
        this.currentGreetingKey = 'night01';
      } else if (hour >= 6 && hour < 12) {
        this.currentGreetingKey = 'morning';
      } else if (hour >= 12 && hour < 13) {
        this.currentGreetingKey = 'noon';
      } else if (hour >= 13 && hour < 18) {
        this.currentGreetingKey = 'afternoon';
      } else {
        // hour >= 18 && hour < 22
        this.currentGreetingKey = 'afternoon02';
      }
    }
  }
};
</script>

<style scoped>
.header-card {
  /* 替换原背景色为动态背景图 */
  background-size: 100% 100%; /* 强制拉伸填满，图片会变形 */
  background-position: center;
  border-radius: 8px;
  padding: 20px 30px;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 160px;
}

.left-content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.time-icon {
  font-size: 36px;
  line-height: 1;
  flex-shrink: 0;
}

.greeting-wrap {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.greeting-title {
  margin: 0 0 6px 0;
  font-size: 22px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.greeting-subtitle {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.night-mode .greeting-title,
.night-mode .greeting-subtitle {
  color: #ffffff;
}
</style>
